import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-qrush-mobile-app',
  templateUrl: './qrush-mobile-app.component.html',
  styleUrls: ['./qrush-mobile-app.component.css']
})
export class QrushMobileAppComponent implements OnInit {

  constructor(private commonScriptComponent:CommonScriptComponent) { }

  ngOnInit() {
    this.commonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/qrush-mobile-app/qrush-mobile-app.component.ts